import { ButtonWithSound } from '../Button/Button';
import './ChatChallengeTryAgain.scss';

const ChatChallengeTryAgain = (props) => {
    const handleTryAgain = () => {
        props.onTryAgain();
    };

    return (
        <div className='chat-challenge-try-again'>
            <div className='try-again-content'>
                <h1 className='try-again-title'>
                    Great Effort! Try again!
                </h1>
                
                <div className='score-message'>
                    <p>You got <span className='score-text'>{props.score}/{props.total}</span> correct.</p>
                    <p>Take the Chat Challenge again to master being a Chat Challenge Champion.</p>
                </div>

                <div className='try-again-button-container'>
                    <ButtonWithSound
                        button={true}
                        onClick={handleTryAgain}
                        className='try-again-button'
                        label='Try Again'
                    />
                </div>
            </div>
        </div>
    );
};

export default ChatChallengeTryAgain;

